import compositionAccess from "./Access/composition.js";
import compositionDPI from "./DPI/composition.js";
import compositionInternet from "./Internet/composition.js";
import compositionPolicyRate from "./PolicyRate/composition.js";
import compositionSubscriberGroup from "./SubscriberGroup/composition.js";
import compositionSubscriberID from "./SubscriberID/composition.js";
import compositionThroughput from "./Throughput/composition.js";
import compositionTime from "./Time/composition.js";
import compositionVLAN from "./VLAN/composition.js";
import compositionInterface from "./Interface/composition.js";
import compositionDSCP from "./DSCP/composition.js";
import viewAccess from "./Access/component.jsx";
import viewDPI from "./DPI/component.jsx";
import viewInternet from "./Internet/component.jsx";
import viewPolicyRate from "./PolicyRate/component.jsx";
import viewSubscriberGroup from "./SubscriberGroup/component.jsx";
import viewSubscriberID from "./SubscriberID/component.jsx";
import viewThroughput from "./Throughput/component.jsx";
import viewTime from "./Time/component.jsx";
import viewVLAN from "./VLAN/component.jsx";
import viewInterface from "./Interface/component.jsx";
import viewDSCP from "./DSCP/component.jsx";

export const compositions = [
  compositionAccess,
  compositionDPI,
  compositionInternet,
  compositionPolicyRate,
  compositionSubscriberGroup,
  compositionSubscriberID,
  compositionThroughput,
  compositionTime,
  compositionVLAN,
  compositionInterface,
  compositionDSCP
]

export const viewOfType = Object.fromEntries(
  compositions.map( ({cliType, viewURL}) => [cliType, viewURL])
) 

export const views = [
  viewAccess,
  viewDPI,
  viewInternet,
  viewPolicyRate,
  viewSubscriberGroup,
  viewSubscriberID,
  viewThroughput,
  viewTime,
  viewVLAN,
  viewInterface,
  viewDSCP
]
const itsViewURL = ({viewURL}) => `/${viewURL}`;

const zip = (one, another) => one.map( (item, index) => [item, another[index]]);

const viewsAndPaths = ({profile}) => profile === null ? [] :
  zip(views, compositions.map(itsViewURL))
  .map(([view, path]) => ({view, path}))

export default viewsAndPaths;
